import $ from "jquery";

// FIXME: only for demonstration. Use accordion plugin. Use "enquire" to bind only on the right breakpoint

const footer = {
    bindCollapse: function () {
        $('.page-footer').on('click', '.page-footer__title', (e) => {
            let $this = $(e.currentTarget);
            // show next sibling
            $this.next('.page-footer__content').show();
        });
    },
    unbindCollapse: function () {
    },
    bindSecondLayerLink: function () {
        $('a.showSecondLayer').on('click', function (e) {
            e.preventDefault();
            window.__ucCmp.showSecondLayer();
        });
    },
};

$(function () {
    footer.bindCollapse();
    footer.bindSecondLayerLink();
});

export default footer;